module.exports = __webpack_public_path__ + "startpage-746fed5a/template-1-2x-f6c0de88ded5adc1880cc2b3917f4ea2.jpg";